import { gameNames, number, teamId } from './analyticsModel.mjs';

export const competenceColors = {
  'Spostrzegawczość': '#99d5ff', 'Refleks': '#ffa8a8', 'Koncentracja': '#c3b1ff',
  'Pamięć': '#ffe08a', 'Koordynacja ruchowa': '#8de0cc', 'Działanie pod presją czasu': '#ffbe8a',
  'Dokładność': '#b9df8a', 'Wykorzystanie wiedzy': '#b2c7ef', 'Podejmowanie decyzji': '#f5a9d0',
  'Logiczne myślenie': '#83d8e6', 'Wyobraźnia': '#d8b5df', 'Kreatywność': '#e3cd9e', 'Cierpliwość': '#c4d4d9',
};
export const gameCompetencies = {
  'Pacnij Kreta': ['Spostrzegawczość', 'Refleks', 'Koordynacja ruchowa', 'Działanie pod presją czasu'],
  'Gra w 3 kubki': ['Koncentracja', 'Pamięć', 'Spostrzegawczość'],
  'Tor wspinaczkowy': ['Koordynacja ruchowa', 'Działanie pod presją czasu'],
  'Gdzie to jest?': ['Wykorzystanie wiedzy', 'Pamięć', 'Dokładność'],
  'Trivia': ['Wykorzystanie wiedzy', 'Pamięć', 'Podejmowanie decyzji'],
  'Sudoku': ['Logiczne myślenie', 'Koncentracja', 'Wyobraźnia'],
  'Cztery Kształty': ['Spostrzegawczość', 'Wyobraźnia', 'Kreatywność', 'Koordynacja ruchowa', 'Pamięć'],
  'Muzyczny Refleks': ['Refleks', 'Koordynacja ruchowa', 'Spostrzegawczość', 'Koncentracja'],
  'Kosmiczny tor przeszkód': ['Refleks', 'Koordynacja ruchowa', 'Koncentracja'],
  'Wyzwanie Stolarza': ['Cierpliwość', 'Dokładność', 'Wykorzystanie wiedzy'],
};
export const competenciesFor = key => gameCompetencies[gameNames[key] || key] || [];
export function matchesCompetencies(key, selected, mode = 'any') {
  if (!selected.length) return true;
  const values = competenciesFor(key);
  return mode === 'all' ? selected.every(value => values.includes(value)) : selected.some(value => values.includes(value));
}
const mean = values => values.length ? values.reduce((a, b) => a + b, 0) / values.length : null;

// Equal weighting: aliases -> one school/game -> one game -> competence.
// Never treat the sum of attempts as a weight for the service's unweighted averages.
export function competenceProfile(rows, competence, school = 'all') {
  const games = new Map();
  rows.forEach(row => {
    if (!competenciesFor(row.booth_name).includes(competence)) return;
    const score = number(row.success_rate), id = teamId(row);
    if (score === null || score < 0 || score > 1 || id == null) return;
    const title = gameNames[row.booth_name] || row.booth_name;
    if (!games.has(title)) games.set(title, new Map());
    const schools = games.get(title);
    if (!schools.has(String(id))) schools.set(String(id), []);
    schools.get(String(id)).push(score);
  });
  const applicable = [...games.entries()].filter(([, schools]) => school === 'all' || schools.has(school));
  const scores = applicable.map(([, schools]) => school === 'all' ? mean([...schools.values()].map(mean)) : mean(schools.get(school)));
  const benchmark = applicable.map(([, schools]) => mean([...schools.values()].map(mean)));
  return { score: mean(scores), benchmark: mean(benchmark), games: applicable.map(([title]) => title) };
}
